import { ApiBase } from 'utils/api';


export default class PermissionApi {
    private base: ApiBase;

    constructor(base: ApiBase) {
        this.base = base;
    }

    roles = () => {
        return this.base.axios.get(`/api/roles`);
    };

    permissions = () => {
        return this.base.axios.get(`/api/permissions`);
    };

    createRole = (name: string) => {
        return this.base.axios.post(`/api/roles`, {name});
    };

    createPermission = (name: string) => {
        return this.base.axios.post(`/api/permissions`, {name});
    };

    updateRole = (id: number, name: string) => {
        return this.base.axios.post(`/api/roles/${id}`, {name});
    };

    updatePermission = (id: number, name: string) => {
        return this.base.axios.post(`/api/permissions/${id}`, {name});
    };

    deleteRole = (id: number) => {
        return this.base.axios.delete(`/api/role/${id}`);
    };

    deletePermission = (id: number) => {
        return this.base.axios.delete(`/api/permissions/${id}`);
    };

    attach = (role_id: number, permission_id: number) => {
        return this.base.axios.put(`/api/permission/${permission_id}/role/${role_id}`);
    };

    detach = (role_id: number, permission_id: number) => {
        return this.base.axios.delete(`/api/permission/${permission_id}/role/${role_id}`);
    };
}
